import React, {useCallback, useEffect, useState} from 'react';

import {
    Button,
    Empty,
    Modal,
    Spin
} from 'antd';

import {
    getHelpDocuments
} from '../../../../request/api';

import {DownloadHelpOperation} from "../../../operation";
import {useTranslation} from "react-i18next";

const HelpDocument = () => {

    const { t, i18n } = useTranslation();

    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [documentList, setDocumentList] = useState([]);
    const [loading, setLoading] = useState(false);

    const helpDocumentClickHandler = () => {
        setShowDocumentModal(true)
    }

    const getLanguageId = useCallback(() => {
        const language = i18n.language || '';
        if (language === 'zhCN' || language.toLowerCase().startsWith('zh')) {
            return 1;
        }
        if (language.toLowerCase().startsWith('en')) {
            return 3;
        }
        return 2;
    }, [i18n.language]);

    const loadHelpDocuments = useCallback(() => {
        setLoading(true);
        getHelpDocuments(getLanguageId()).then(res => {
            if (res && res.success) {
                setDocumentList(res.data || []);
            } else {
                setDocumentList([]);
            }
        }).catch(() => {
            setDocumentList([]);
        }).finally(() => {
            setLoading(false);
        });
    }, [getLanguageId]);

    useEffect(() => {
        if (showDocumentModal) {
            loadHelpDocuments();
        }
    }, [showDocumentModal, i18n.language, loadHelpDocuments]);

    const downloadHelpDocument = (fileUrl) => {
        if (fileUrl) {
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        }
    };

    const emptyDescription = i18n.language === 'zhCN' ? '暂无帮助文档' : 'ヘルプドキュメントがありません';

    return (
        <>
            <DownloadHelpOperation btnText={t('All.Operation.Download.downloadHelpDocs')} type='addPlant' onClick={helpDocumentClickHandler} />
            {
                <Modal
                    title={t('All.Operation.Download.downloadHelpDocs')}
                    closable={{'aria-label': 'Custom Close Button'}}
                    open={showDocumentModal}
                    className='ModalDefault'
                    onCancel={() => setShowDocumentModal(false)}
                    footer={null}
                    zIndex={10000}
                >
                    <div style={{padding: '20px'}}>
                        <Spin spinning={loading}>
                            {documentList.length > 0 ? documentList.map(item => (
                                <div
                                    key={item.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '12px',
                                        padding: '8px 0'
                                    }}
                                >
                                    <span style={{wordBreak: 'break-all'}}>{item.title || item.originalFileName}</span>
                                    <Button
                                        type='link'
                                        onClick={() => downloadHelpDocument(item.fileUrl)}
                                    >
                                        {t('All.Operation.Download.download')}
                                    </Button>
                                </div>
                            )) : (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyDescription} />
                            )}
                        </Spin>
                    </div>
                </Modal>
            }
        </>
    );
};

export default HelpDocument;
